// Operator bulk-import of existing caregivers as APPLYING shells (agency
// absorption + staging tester load). Per Convention 06 (per-resource schema
// file).
//
// The import creates account shells only; each caregiver completes vetting +
// onboarding themselves (upload docs, accept the IC agreement, enter banking)
// via the welcome magic-link. So a row is the public-apply shape MINUS:
//   - _botField / turnstileToken — operator-authed, not a public CAPTCHA form
//   - privacy/contractor consent timestamps — the caregiver gives those when
//     they accept the agreement during onboarding; the operator never forges
//     consent on their behalf.
// Reusing CaregiverApplicationRequestSchema.omit(...) keeps every field
// validator (email / names / DOB / gender / phone / postal / roles) in exactly
// one place — zero drift between the public form and the bulk import.
import { z } from 'zod';
import { CaregiverApplicationRequestSchema } from './application.schema.js';
export const CaregiverImportRowSchema = CaregiverApplicationRequestSchema.omit({
    _botField: true,
    turnstileToken: true,
    privacyPolicyAcceptedAt: true,
    contractorAgreementAcceptedAt: true,
});
export const CaregiverImportRequestSchema = z.object({
    rows: z.array(CaregiverImportRowSchema).min(1).max(500),
    /** Send each newly-created caregiver the welcome magic-link so they can sign
     *  in and complete onboarding. Default true; set false to load silently and
     *  invite as a deliberate second step. Rows skipped as already-existing are
     *  never emailed regardless of this flag. */
    sendInvite: z.boolean().default(true),
    /** Validate + report the per-row plan WITHOUT writing anything or sending any
     *  email. Lets the operator preview a load before committing it. */
    dryRun: z.boolean().default(false),
});
export const CaregiverImportRowResultSchema = z.object({
    email: z.string(),
    /** created = a new APPLYING caregiver (or, in dryRun, would be created);
     *  skipped = a caregiver already exists for this email (idempotent no-op);
     *  failed  = validation or a write error for this row (others still proceed). */
    status: z.enum(['created', 'skipped', 'failed']),
    caregiverId: z.string().nullable(),
    reason: z.string().nullable(),
});
export const CaregiverImportResponseSchema = z.object({
    dryRun: z.boolean(),
    summary: z.object({
        total: z.number().int(),
        created: z.number().int(),
        skipped: z.number().int(),
        failed: z.number().int(),
    }),
    results: z.array(CaregiverImportRowResultSchema),
});
//# sourceMappingURL=import.schema.js.map